import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { api } from '../services/api.js';
import { useAuth } from '../hooks/useAuth.jsx';
import { validarNome, MENSAGENS_ERRO } from '../utils/validators.js';

export default function Perfil() {
  const { usuario, carregando, recarregar } = useAuth();
  const [perfil, setPerfil] = useState(null);
  const [nome, setNome] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState(null);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    let ativo = true;
    if (!usuario) return;
    api.perfilGet().then((p) => {
      if (!ativo) return;
      setPerfil(p);
      setNome(p.nome || '');
    }).catch((e) => setErro(e.message));
    return () => { ativo = false; };
  }, [usuario]);

  if (carregando) return <p aria-live="polite">Carregando…</p>;
  if (!usuario) return <Navigate to="/login" replace />;

  async function salvar(e) {
    e.preventDefault();
    setErro(null);
    setOk(false);
    const erroNome = validarNome(nome);
    if (erroNome) {
      setErro(MENSAGENS_ERRO[erroNome]);
      return;
    }
    setSalvando(true);
    try {
      await api.perfilPut(nome);
      await recarregar();
      setOk(true);
    } catch (err) {
      setErro(MENSAGENS_ERRO[err.codigo] || err.message);
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div className="row gy-4">
      <div className="col-12">
        <h1 className="h3">Meu perfil</h1>
      </div>
      <div className="col-lg-6">
        <div className="card p-3">
          <h2 className="h5">Dados</h2>
          <form onSubmit={salvar} noValidate>
            <div className="mb-3">
              <label htmlFor="campo-perfil-email" className="form-label">E-mail</label>
              <input id="campo-perfil-email" type="email" className="form-control" value={perfil?.email || ''} readOnly />
            </div>
            <div className="mb-3">
              <label htmlFor="campo-perfil-nome" className="form-label">Nome</label>
              <input id="campo-perfil-nome" type="text" className="form-control" value={nome} maxLength={80} onChange={(e) => setNome(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" disabled={salvando}>
              {salvando ? 'Salvando…' : 'Salvar'}
            </button>
            <div role="status" aria-live="polite" className="mt-3">
              {erro && <div className="alert alert-danger">{erro}</div>}
              {ok && <div className="alert alert-success">Atualizado.</div>}
            </div>
          </form>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="card p-3">
          <h2 className="h5">Meus links</h2>
          {!perfil?.links?.length ? (
            <p className="text-secondary">Nenhum link cadastrado ainda.</p>
          ) : (
            <ul className="list-group">
              {perfil.links.map((l) => (
                <li key={l.short_link} className="list-group-item bg-transparent text-light border-secondary">
                  <div><strong>{l.nome}</strong></div>
                  <div className="text-secondary small">/{l.short_link} — {l.cliques} cliques</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
